import {cloneDeep, omit} from 'lodash'
import createModel from 'utils/model'
import {search, detail, syncStatus, manualSync, exportTaskId} from 'crm/services/customer'
import {corpTags} from 'crm/services/tags'
import {findDuplicateCorpTagNames} from 'crm/components/customer-detail/utils'
import {filterEmptyArrParams, filterTagParams} from '../utils'

function getInitParams() {
    return {
        limit: 10,
        offset: 0,
        keyword: undefined, // 姓名/备注
        mobile: undefined, // 手机号
        department_id: undefined, // number 部门id
        user_id: undefined, // number 员工id
        wx_createtime_from: undefined, // 添加开始时间
        wx_createtime_to: undefined, // 添加结束时间
        gender: undefined, // number 性别 0 未知, 1 男, 2 女
        group_id: undefined, // 分组id
        corp_tags: {}, // {op: 'AND/OR', except: true, values: [{id: id}]}
        personal_tags: {}, // {op: 'AND/OR', except: true, values: [{name: '标签名称', group_name: '分组名称'}]}
        is_delete: false,
        is_block: undefined, // 被客户删除
        is_first: undefined, // 首次添加客户
        birth_province: undefined, // 出生省
        birth_city: undefined, // 出生市
        province: undefined, // 所在省
        city: undefined, // 所在市
        birth_month: undefined, // number 生日月份
        add_way: undefined, // 添加来源
        type: undefined, // 客户类型
        order_by: undefined, // 排序
        store_poly_ids: [], // 门店分组
        states: undefined, // 包含渠道 id 多选
        except_channel_ids: undefined, // 不包含渠道 id 多选
    }
}

function getInitState() {
    return {
        params: getInitParams(),
        searchParams: {},
        list: [],
        current: 1,
        total: 0,
        selectedRowKeys: [],
        selectedStoreGroups: [],
        checkAll: false, // 全选
        unSelectIds: [], // 勾选全选后，未勾选的客户
        rows: {}, // {id: record}
        sortedInfo: null, // 排序
        statusInfo: {}, // 同步状态
        allCorpTags: null, // 所有企业标签
        duplicateCorpTagNames: [], // 重名的企业标签
    }
}

export default createModel({
    namespace: 'crm_customer',
    state: getInitState(),

    subscriptions: {},

    effects: {
        *search({payload}, {select, call, put}) {
            const {params, selectedRowKeys, checkAll, unSelectIds, allCorpTags} = yield select(
                ({crm_customer}) => crm_customer,
            )
            let newSelectedRowKeys = [...selectedRowKeys]
            let query = {...params, ...payload?.params}

            if (payload?.page) {
                query.offset = query.limit * (payload.page - 1)
            }
            if (query?.store_poly_ids && query?.store_poly_ids?.length === 0) {
                query = omit(query, ['store_poly_ids'])
            }
            const searchQuery = cloneDeep(query)

            filterEmptyArrParams('states', searchQuery)
            filterEmptyArrParams('except_channel_ids', searchQuery)
            filterTagParams('corp_tags', searchQuery)
            filterTagParams('personal_tags', searchQuery)

            const res = yield call(search, searchQuery)

            if (res && res.data) {
                // 初始化当前页选中的客户ids
                if (checkAll) {
                    newSelectedRowKeys = res.data.map((item) => item.id)
                    if (unSelectIds.length) {
                        unSelectIds.forEach((unSelectId) => {
                            const index = newSelectedRowKeys.findIndex(
                                (item) => unSelectId === item,
                            )
                            if (index > -1) {
                                newSelectedRowKeys.splice(index, 1)
                            }
                        })
                    }
                }
                let customerData = res?.data || []
                let allCorpTagsData = []
                let duplicateCorpTagNames = []
                try {
                    if (allCorpTags) {
                        allCorpTagsData = cloneDeep(allCorpTags)
                    } else {
                        const allCorpTagsRes = yield call(corpTags)
                        allCorpTagsData = allCorpTagsRes?.data || []
                    }
                    duplicateCorpTagNames = findDuplicateCorpTagNames(allCorpTagsData)
                    customerData = customerData.map((customer) => {
                        const tags = customer.corp_tags
                        if (tags.length) {
                            const tagNames = [] // 其他企业标签名
                            tags.forEach((tag) => {
                                const {group_name: groupName, name: tagName} = tag
                                const currentTagName = duplicateCorpTagNames.includes(tagName)
                                    ? `${groupName}：${tagName}`
                                    : tagName
                                tagNames.push({name: currentTagName})
                            })
                            return {
                                ...customer,
                                corpTagNames: tagNames,
                            }
                        }
                        return customer
                    })
                } finally {
                    yield put({
                        type: 'setProperty',
                        payload: {
                            list: customerData,
                            total: res.pagination.rows_found,
                            current: parseInt(res.pagination.offset / res.pagination.limit, 10) + 1,
                            selectedRowKeys: newSelectedRowKeys,
                            params: query,
                            searchParams: query,
                            allCorpTags: allCorpTagsData,
                            duplicateCorpTagNames,
                        },
                    })
                }
            }
            return res
        },
        *detail({payload}, {call}) {
            return yield call(detail, payload)
        },
        *syncStatus(_, {call, put}) {
            const {data} = yield call(syncStatus)
            yield put({
                type: 'setProperty',
                payload: {
                    statusInfo: data,
                },
            })
        },
        *manualSync(_, {call}) {
            return yield call(manualSync)
        },
        *exportTaskId({payload}, {call}) {
            return yield call(exportTaskId, payload)
        },
    },

    reducers: {
        setProperty(state, action) {
            return {...state, ...action.payload}
        },
        resetParams(state) {
            return {...state, params: getInitParams()}
        },
        resetState(state) {
            return {...state, ...getInitState()}
        },
    },
})
